import { Component } from "@angular/core";

@Component({
    selector: 'app-home-contact',
    templateUrl: './home-contact.component.html',
    styleUrls: ['./home-contact.component.scss']
})
export class HomeContactComponent {
    
}